export default "__VITE_ASSET__jbCKzxli__";